import { useTranslations } from 'next-intl';

import TgIcon from '@/fo/icons/base/socials/tg24.svg';
import { UiKitButtonBase } from '@/fo/ui/kit/button/base';
import { UiKitLabelBase } from '@/fo/ui/kit/label/base';

import { IPHONE_IMAGES } from '../mock';

import { styles } from './UiArticleSectionSupport.styles';

export interface UiArticleSectionSupportProps {
  className?: string;
}

/**
 * Блок поддержки с информацией о консультации и контактах
 */
export function UiArticleSectionSupport({
  className
}: UiArticleSectionSupportProps) {
  const slots = styles();

  const t = useTranslations();

  const images = IPHONE_IMAGES;

  return (
    <div className={slots.base({ className })}>
      <div className={slots.mainContent()}>
        <div className={slots.header()}>
          <h2 className={slots.title()}>
            {t('article.page.whereToBuy.supportBlock.title')}
          </h2>
          <p className={slots.description()}>
            {t('article.page.whereToBuy.supportBlock.description')}
          </p>
        </div>
        <div className={slots.contacts()}>
          <div className={slots.phoneBlock()}>
            <UiKitButtonBase
              className={slots.contact()}
              color="ghost"
              href="tel:88007759359"
              as="link"
            >
              8 800 775 93 59
            </UiKitButtonBase>
            <span className={slots.time()}>
              {t('article.page.whereToBuy.supportBlock.time')}
            </span>
          </div>
          <UiKitButtonBase
            className={slots.contact()}
            color="ghost"
            href="mailto:support@ru.naos.com"
            as="link"
          >
            support@ru.naos.com
          </UiKitButtonBase>
        </div>
      </div>
      <div className={slots.onlineSupport()}>
        <UiKitLabelBase
          uppercase
          color="done"
        >
          {t('onlineChat')}
        </UiKitLabelBase>
        <span className={slots.onlineSupportTitle()}>
          {t('article.page.whereToBuy.supportBlock.onlineSupportTittle')}
        </span>
        <div className={slots.chats()}>
          <a
            href="https://t.me/Naos_Ru_Bot"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className={slots.chatButton({
              telegram: true
            })}
          >
            <TgIcon />
            {t('telegram')}
          </a>
        </div>
      </div>
      <picture className={slots.backgroundImage()}>
        <source
          srcSet={images.desktopFullHD}
          media="(min-width: 1920px)"
        />
        <source
          srcSet={images.desktopHD}
          media="(min-width: 1440px)"
        />
        <source
          srcSet={images.laptop}
          media="(min-width: 1280px)"
        />
        <source
          srcSet={images.tablet}
          media="(min-width: 640px)"
        />
        <source
          srcSet={images.mobile}
          media="(min-width: 375px)"
        />
        <img
          src={images.mobile}
          alt={t('article.page.whereToBuy.supportBlock.altText')}
        />
      </picture>
    </div>
  );
}
